// First we need to import axios.js
import axios from 'axios';

const baseURL = `${window.location.protocol}//${window.location.host}`;
const instance = axios.create({
    baseURL,
    withCredentials: true,
});
// fetch('/config.json')
//     .then((res) => res.json())
//     .then((config) => {
//         instance.defaults.baseURL = config.REACT_APP_BASE_URL;
//     })
//     .catch((err) => {
//         console.error('Failed to load config.json', err);
//     });

instance.interceptors.request.use(request => {

    return request;
}, error => {
    // return Promise.reject(error);
    console.error(error)
});
instance.interceptors.response.use(response => {
      const contentType = response.headers['content-type'];
    if (response.config.responseType === 'blob' || contentType?.includes('application/octet-stream') || contentType?.includes('application/pdf')) {
      return response;
    }
    if(response.config.singleReturn){
        return response
    }

    if(response.data.status === 'success' || response.data.status === 'ambiguous'){
        return response;
    }else{
        // return response.data;
        return Promise.reject( response.data);
    }
}, error => {
    return Promise.reject(error);
});


export default instance;